import { gsap } from 'gsap';

export function slideIn(targetEl) {
    return new Promise( (resolve) => {
        targetEl.style.display = "block";
        targetEl.style.height = 'auto';
        const height = targetEl.offsetHeight
        targetEl.style.height = '0px'
        gsap.to(targetEl, {
            height: `${height}px`,
            onComplete: resolve
        })
    });
}

export function slideOut(targetEl) {
    return new Promise( (resolve) => {
        gsap.to(targetEl, {
            height: '0px',
            onComplete: () => {
                targetEl.style.display = "none"
                resolve();
            }
        })
    })
}
